var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/AWS/App role@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8A032",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF807",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 9.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9117187,12.0266663 C18.7170236,11.5266663 18.2517312,11.2 17.7336426,11.2 L17.9533854,11.2 L17.9533854,9.6 C17.9533854,5.8200002 15.5167116,2.62333374 12.1454953,1.50333354 L12.1454953,1.32006632 C12.1435477,0.591666667 11.5594583,0 10.8367722,0 L8.17042311,0 C7.45070681,0 6.86463759,0.591666667 6.86463759,1.31866659 L6.86463759,1.5019338 C3.49111161,2.62233276 1.0554273,5.8200002 1.0554273,9.6 L1.0554273,11.2 L1.27523599,11.2 C0.754835702,11.2 0.29119438,11.525 0.0945178824,12.0269999 C-0.090080429,12.4976664 0.000667852791,13.0466665 0.323467664,13.4216665 C0.548226562,13.6866669 2.71694554,16 9.50359716,16 C16.2902488,16 18.4596284,13.6853333 18.6807226,13.425 C18.977717,13.0466665 19.0965159,12.4966665 18.9117182,12.0266663 L18.9117187,12.0266663 Z M2.6390675,9.6 C2.6390675,6.72533366 4.38968445,4.27333374 6.86298802,3.22666626 L6.86298802,9.33333333 C6.86298802,9.775 7.21773131,10.1333333 7.65497303,10.1333333 C8.09221475,10.1333333 8.44695803,9.775 8.44695803,9.33333333 L8.44695803,1.6 L10.5592484,1.6 L10.5592484,9.33333333 C10.5592484,9.775 10.9139916,10.1333333 11.3512334,10.1333333 C11.7884751,10.1333333 12.1432184,9.775 12.1432184,9.33333333 L12.1432184,3.22666626 C14.5888016,4.27333374 16.3674677,6.72666677 16.3674677,9.6 L16.3674677,11.2 L2.6390675,11.2 L2.6390675,9.6 L2.6390675,9.6 Z M9.50359766,14.4 C5.17407974,14.4 2.98292093,13.3936666 2.0655387,12.8 L16.9416576,12.8 C16.0242744,13.3933329 13.8331161,14.4 9.50359766,14.4 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppRole);
export default __webpack_public_path__ + "static/media/app-role.ce8f350b103f622c3192095201981094.svg";
export { ForwardRef as ReactComponent };